type Props = {
  className?: string;
};

/** AIチャット用ブランドアバター（フォルダ+きらめきのグラデーション）。事業チャット・汎用チャット共通で使用する */
export const AIAvatarIcon = ({ className }: Props) => (
  <svg
    width="40"
    height="30"
    viewBox="0 0 40 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-hidden="true"
  >
    <g clipPath="url(#ai-avatar-clip)">
      <path
        d="M0 7.93C0 5.947 1.626 4.34 3.631 4.34h28.293c2.006 0 3.631 1.608 3.631 3.59v18.48c0 1.983-1.625 3.59-3.63 3.59H3.63C1.626 30 0 28.393 0 26.41V7.93Z"
        fill="url(#ai-avatar-g0)"
      />
      <path
        d="M.01 9.03c0-.45-.022-5.368.009-6.136 0-1.31.931-2.677 2.144-2.78C3.376.01 5.635.04 7.3.01c1.334-.022 2.63-.007 3.957.02 2.024.064 2.822 3.207 4.642 3.48.737.111 2.124.031 2.919.031 3.029.025 6.058.024 9.087-.003 1.636 0 3.27-.026 4.902.06 1.47.079 2.751 1.278 2.751 2.758.005.413-.033 2.035-.033 2.483-.255-.993-1.335-2.078-2.379-2.12-2.384-.093-4.814-.047-7.201-.048l-13.211-.003-7.208.005c-.977.003-1.951-.025-2.926.04C1.381 6.794.298 7.862.01 9.029Z"
        fill="url(#ai-avatar-g1)"
      />
      <path
        d="M16.492 15.861a1.513 1.513 0 1 1-3.026 0 1.513 1.513 0 0 1 3.026 0ZM8.927 15.861a1.513 1.513 0 1 1-3.026 0 1.513 1.513 0 0 1 3.026 0Z"
        fill="#059669"
      />
      <path
        d="M8.549 19.9c1.082 0 1.219 0 2.723 0s1.413 0 2.723 0h1.513c0 2.314-1.897 4.19-4.236 4.19-2.34 0-4.237-1.876-4.237-4.19h1.514Z"
        fill="#059669"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.222 8.824c.322 0 .598.228.656.543l.224 1.225a1.4 1.4 0 0 0 1.094 1.113l1.234.223a.666.666 0 0 1 0 1.302l-1.234.223a1.4 1.4 0 0 0-1.094 1.113l-.224 1.224a.666.666 0 0 1-1.312 0l-.224-1.224a1.4 1.4 0 0 0-1.095-1.113l-1.233-.223a.666.666 0 0 1 0-1.302l1.233-.223a1.4 1.4 0 0 0 1.095-1.113l.224-1.225a.667.667 0 0 1 .656-.543Z"
        fill="url(#ai-avatar-g2)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.444 6.176a.667.667 0 0 1 .641.48l.173.601a1.33 1.33 0 0 0 .763.758l.606.172a.667.667 0 0 1 0 1.272l-.606.173a1.33 1.33 0 0 0-.763.757l-.173.601a.667.667 0 0 1-1.282 0l-.173-.601a1.33 1.33 0 0 0-.763-.757l-.606-.173a.667.667 0 0 1 0-1.272l.606-.172a1.33 1.33 0 0 0 .763-.758l.173-.601a.667.667 0 0 1 .641-.48Z"
        fill="url(#ai-avatar-g3)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.666 15a.667.667 0 0 1 .647.501 1.33 1.33 0 0 0 .626.621.667.667 0 0 1 0 1.285 1.33 1.33 0 0 0-.626.621.667.667 0 0 1-1.293 0 1.33 1.33 0 0 0-.626-.621.667.667 0 0 1 0-1.285 1.33 1.33 0 0 0 .626-.621.667.667 0 0 1 .646-.501Z"
        fill="url(#ai-avatar-g4)"
      />
    </g>
    <defs>
      <linearGradient
        id="ai-avatar-g0"
        x1="17.778"
        y1="4.34"
        x2="17.778"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0FDF8" />
        <stop offset="1" stopColor="#DDF9EC" />
      </linearGradient>
      <linearGradient
        id="ai-avatar-g1"
        x1="0"
        y1="4.514"
        x2="35.548"
        y2="4.514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07AF7A" />
        <stop offset="1" stopColor="#83E4C1" />
      </linearGradient>
      <linearGradient
        id="ai-avatar-g2"
        x1="26.958"
        y1="13.222"
        x2="39.111"
        y2="13.222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07AF7A" />
        <stop offset=".3" stopColor="#07AF7A" />
        <stop offset=".7" stopColor="#059669" />
        <stop offset="1" stopColor="#07AF7A" />
      </linearGradient>
      <linearGradient
        id="ai-avatar-g3"
        x1="26.958"
        y1="13.221"
        x2="39.111"
        y2="13.221"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07AF7A" />
        <stop offset=".3" stopColor="#07AF7A" />
        <stop offset=".7" stopColor="#059669" />
        <stop offset="1" stopColor="#07AF7A" />
      </linearGradient>
      <linearGradient
        id="ai-avatar-g4"
        x1="26.958"
        y1="13.222"
        x2="39.111"
        y2="13.222"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#07AF7A" />
        <stop offset=".3" stopColor="#07AF7A" />
        <stop offset=".7" stopColor="#059669" />
        <stop offset="1" stopColor="#07AF7A" />
      </linearGradient>
      <clipPath id="ai-avatar-clip">
        <rect width="40" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
